import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { LOGO } from "../../data/content";
import { SITE_NAV } from "../site/SiteHeader";
import { SearchModal } from "../SearchModal";

const PRIMARY = ["/solutions", "/services", "/industries", "/projects", "/about", "/insights"];

export const PanHeader = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const primary = SITE_NAV.filter((n) => PRIMARY.includes(n.to));
  const more = SITE_NAV.filter((n) => !PRIMARY.includes(n.to));

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed inset-x-0 top-0 z-40 transition-colors duration-300 ${scrolled || open ? "bg-nx-black/95 backdrop-blur-md border-b border-white/10" : "bg-gradient-to-b from-black/70 to-transparent"}`} data-testid="site-header">
      <div className="nx-wrap flex items-center justify-between h-16 sm:h-[72px]">
        <Link to="/" className="flex items-center gap-3" data-testid="site-logo" aria-label="NexSecure Technologies — home">
          <img src={LOGO.iconPan} alt="" className="h-9 sm:h-10 w-auto" />
          <img src={LOGO.namePan} alt="NexSecure" className="h-4 sm:h-5 w-auto" />
        </Link>
        <nav className="hidden xl:flex items-center gap-1" aria-label="Primary" data-testid="site-nav">
          {primary.map((n) => (
            <Link key={n.to} to={n.to} className="px-4 py-2 text-[15px] text-white/90 hover:text-nx-orange transition-colors" data-testid={`pan-nav-${n.label.toLowerCase()}`}>{n.label}</Link>
          ))}
          <div className="relative group">
            <button className="flex items-center gap-1 px-4 py-2 text-[15px] text-white/90 hover:text-nx-orange transition-colors" data-testid="pan-nav-more">More <ChevronDown size={14} /></button>
            <div className="absolute right-0 top-full hidden group-hover:block pt-2 z-50">
              <div className="rounded-2xl border border-white/10 bg-nx-black2 shadow-2xl shadow-black/60 p-5 grid grid-cols-2 gap-x-8 gap-y-3 min-w-[20rem]">
                {more.map((n) => (
                  <Link key={n.to} to={n.to} className="text-sm text-slate-300 hover:text-nx-orange transition-colors" data-testid={`pan-nav-more-${n.label.toLowerCase()}`}>{n.label}</Link>
                ))}
              </div>
            </div>
          </div>
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <SearchModal />
          <Link to="/support" className="hidden md:inline-flex items-center rounded-full border border-white/30 text-white text-sm px-5 py-2.5 hover:border-nx-orange hover:text-nx-orange transition-colors" data-testid="pan-nav-support">Support</Link>
          <Link to="/request-a-quote" className="hidden sm:inline-flex items-center whitespace-nowrap rounded-full bg-nx-orange text-white text-sm font-medium px-5 py-2.5 hover:bg-nx-orangelight transition-colors" data-testid="pan-nav-cta">Get a Quote</Link>
          <button className="xl:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="site-mobile-menu-button" aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="xl:hidden border-t border-white/10 bg-nx-black px-6 py-5 grid grid-cols-2 gap-3 max-h-[75vh] overflow-y-auto" data-testid="site-mobile-nav">
          {SITE_NAV.map((n) => (
            <button key={n.to} onClick={() => { setOpen(false); navigate(n.to); }} className="text-left text-sm text-slate-200 py-2 hover:text-nx-orange">{n.label}</button>
          ))}
          <Link to="/request-a-quote" onClick={() => setOpen(false)} className="col-span-2 mt-2 inline-flex justify-center rounded-full bg-nx-orange text-white text-sm font-medium px-5 py-3">Get a Quote</Link>
        </nav>
      )}
    </header>
  );
};
